import { Ref } from "vue";

export function handleModal(modals: any, firstModal: string, secondModal: string, firstValue: boolean, secondValue: boolean, thirdValue?: boolean,
    thirdModal?: string) {
    modals[firstModal] = firstValue;
    modals[secondModal] = secondValue;
    if (thirdModal !== undefined) {
        modals[thirdModal] = thirdValue;
    }
}

export function validateFields(mandatoryFields: any[], object: any, errors: any, errorMessage: string) {
    errors.value = [];
    let hasError = false;
    let value = null;

    mandatoryFields.forEach((field, index) => {
         if(typeof field != 'string') {
             value = object[field[0]][field[1]];
         }  else {
             value = object[field];
        }
        if (!value) {
            hasError = true;
            errors.value.push(errorMessage);
        } else {
            errors.value.push("");
        }
    });

    if (hasError) {
        return false;
    }
    return true;
}

export function isValidDate(dateString: string): boolean {
    // Controlla se la data segue il formato GG-MM-AAAA
    const regex = /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-\d{4}$/;

    if (!regex.test(dateString)) {
        return false;
    }

    const [day, month, year] = dateString.split('-').map(Number);

    // Controlla se i numeri del giorno, mese e anno sono validi
    if (isNaN(day) || isNaN(month) || isNaN(year)) {
        return false;
    }

    // Verifica se il mese è valido (da 1 a 12)
    if (month < 1 || month > 12) {
        return false;
    }

    // Verifica se il giorno è valido per il mese specificato
    const date = new Date(year, month - 1, day);
    if (date.getDate() !== day) {
        return false;
    }

    // La data è valida
    return true;
}


export function capitaliseFirstLetter(subject: string) {
    return subject.split(' ').map(word => {
        return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(' ');
}

export function compareDates(date1: Date, date2: Date) {
    if (date1 > date2) {
     
        return false;
    }
    return true;
}

